import { apiClient } from '../../config/axios.config'; // Adjust the import path as necessary
import { BASE_HOLIDAY_URL, BASE_URL } from '../apiConfig';

export const fetchHolidayCalendarDetails = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_HOLIDAY_URL}/calendar-details`,
    payload,
  );
  return response;
};

export const fetchHolidayPlanningDetails = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_HOLIDAY_URL}/planning-details`,
    payload,
  );
  return response;
};

export const saveHolidayPlanning = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_HOLIDAY_URL}/save-planning`,
    payload,
  );
  return response;
};
